import { action, makeAutoObservable, observable } from "mobx";
import { SystemItemTypes } from "../enums";
import {
  IAPIPaginationResponse,
  PaginationModel,
} from "@mindmemobile/mm-shared-global";
import {
  PurchaseLinkDetailPageModel,
  PurchaseLinkGridModel,
  PurchaseLinkModel,
} from "../models/PurchaseLinkModels";
import { MerchantAccount } from "../models/MerchantApplicationInputModel";
import { SellerModel } from "../models/SellerModels";
import { IAPIPurchaseLinkGridModel } from "../interfaces/IAPIPurchaseLinkModel";
import { ItemDetailPageModel } from "../models/ItemDetailPageModels";
import { PricingPageInputModel } from "../models/PriceInputs.model";
import { RelatedSectionModel } from "../models/DonationAndItemModel";
import { ProductAttributeInputModel } from "../models/ProductModel";

export default class PurchaseLinkStore {
  @observable purchaseLinkModel: PurchaseLinkModel;
  @observable merchantAccounts: MerchantAccount[] = [];
  @observable detailPage: PurchaseLinkDetailPageModel =
    new PurchaseLinkDetailPageModel();
  public pagination: PaginationModel = new PaginationModel({
    pageNumber: 1,
    pageSize: 999999,
  });
  @observable gridData: PurchaseLinkGridModel[] = [];
  @observable sellers: SellerModel[] = [];

  constructor() {
    this.purchaseLinkModel = new PurchaseLinkModel();
    makeAutoObservable(this);
  }

  @action
  updateSellers(sellers: SellerModel[]) {
    this.sellers = sellers;
  }

  @action
  updatePurchaseLink(data: PurchaseLinkModel) {
    this.purchaseLinkModel = new PurchaseLinkModel(data);
  }

  @action
  updateDetailPage(data: PurchaseLinkDetailPageModel) {
    this.detailPage = new PurchaseLinkDetailPageModel(data);
  }

  deserializeAPIResponse(
    data: IAPIPurchaseLinkGridModel[],
    pagination: IAPIPaginationResponse
  ): void {
    let isFirst = true;
    this.gridData =
      (data &&
        data.map((purchaseLink: any, index: number) => {
          const result = PurchaseLinkGridModel.deserializeAPIModel(
            purchaseLink,
            isFirst
          );
          isFirst = false; // Ensure only the first record gets true
          return result;
        })) ||
      [];
    this.pagination = PaginationModel.deserialize(pagination);
  }

  @action
  updateMerchantAccounts(data: MerchantAccount[]) {
    this.merchantAccounts = data;
  }

  @action
  copySelectedItemDetails(
    itemDetails: ItemDetailPageModel,
    pricingInputs: PricingPageInputModel[] | null,
    relatedSectionData: RelatedSectionModel | null,
    itemType: keyof typeof SystemItemTypes,
    variants: ProductAttributeInputModel | null,
    itemId: string,
    isTrackInventory: boolean
  ) {
    this.updatePurchaseLink(
      new PurchaseLinkModel({
        ...this.purchaseLinkModel,
        itemDetails: new ItemDetailPageModel(itemDetails),
        pricingInputs:
          pricingInputs &&
          pricingInputs.map((price) => new PricingPageInputModel(price)),
        relatedSectionData:
          relatedSectionData && new RelatedSectionModel(relatedSectionData),
        itemType: itemType,
        variants: variants,
        itemId: itemId,
        isTrackInventory: isTrackInventory,
      })
    );
  }

  @action
  resetPurchaseLink() {
    this.purchaseLinkModel = new PurchaseLinkModel();
  }
}
